






































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { AvaliacaoNpsConfigLoja, FormLoja, TipoAvaliacaoNps } from '@/models'

const PERGUNTA_DO_TIPO: Record<TipoAvaliacaoNps, string> = {
	'Geral': 'Quão provável é que você recomende nossa loja a um amigo ou familiar?',
	'Atendimento': 'Como você avalia o atendimento recebido?',
	'Produtos': 'Como você avalia os produtos adquiridos?',
	'Preços e condições': 'Como você avalia os preços e condições de pagamento?',
	'Entrega e retirada': 'Como você avalia o processo de entrega ou retirada?',
	'Motivo': 'Conte-nos o motivo da sua nota.',
	'Sugestão de melhoria': 'Deixe aqui suas sugestões de melhoria.',
}

@Component
export default class SecaoNps extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja

	TIPOS_DE_PERGUNTA: { value: TipoAvaliacaoNps; label: string }[] = [
		{ value: 'Geral', label: 'NPS geral' },
		{ value: 'Atendimento', label: 'Atendimento' },
		{ value: 'Produtos', label: 'Produtos' },
		{ value: 'Preços e condições', label: 'Preços e condições' },
		{ value: 'Entrega e retirada', label: 'Entrega e retirada' },
		{ value: 'Motivo', label: 'Motivo da nota' },
		{ value: 'Sugestão de melhoria', label: 'Sugestão de melhoria' },
	]

	adicionarPergunta() {
		if (!this.loja.avaliacaoNpsConfig) this.$set(this.loja, 'avaliacaoNpsConfig', [])
		this.loja.avaliacaoNpsConfig.push({
			id: '',
			tipo: 'Geral',
			pergunta: PERGUNTA_DO_TIPO.Geral,
			lojaId: this.loja.id,
			ativo: true,
			ordem: this.loja.avaliacaoNpsConfig.length + 1,
			obrigatoria: false,
		})
	}

	removerPergunta(indice: number) {
		this.loja.avaliacaoNpsConfig.splice(indice, 1)
		this.loja.avaliacaoNpsConfig.forEach((pergunta, posicao) => {
			pergunta.ordem = posicao + 1
		})
	}

	aoTrocarOTipo(pergunta: AvaliacaoNpsConfigLoja) {
		const texto = PERGUNTA_DO_TIPO[pergunta.tipo]
		if (texto) pergunta.pergunta = texto
	}
}
